import { render, staticRenderFns } from "./RoleDetail.vue?vue&type=template&id=31e765e6&scoped=true"
import script from "./RoleDetail.vue?vue&type=script&lang=js"
export * from "./RoleDetail.vue?vue&type=script&lang=js"
import style0 from "./RoleDetail.vue?vue&type=style&index=0&id=31e765e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e765e6",
  null
  
)

export default component.exports